export const cardTypeLogos: { [key: string]: string } = {
  'business': 'business.svg',
  'diners': 'diners.svg',
  'irctc-co-brand': 'irctc_co_brand.svg',
  'regalia-gold': 'regalia_gold.svg'
};
